/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

(() => {
    class GlideManager {
        constructor(containerSelector = '.shopify-section') {
            this.containerSelector = containerSelector;
            this.initAll();
            this.bindShopifyEvents();
        }

        initAll() {
            const containers = document.querySelectorAll(this.containerSelector);
            containers.forEach(container => this.initSlidersInContainer(container));
        }

        initSlidersInContainer(container) {
            const sliders = container.querySelectorAll('.glide');
            if (sliders.length === 0) return;

            const glideInstances = [];

            sliders.forEach(slider => {
                if (!slider.dataset.glideInitialized) {
                    const slides = slider.querySelectorAll('.glide__slides > *');
                    const slideCount = slides.length;

                    const minSlidesMobile = slider.dataset.minSlidesMobile ? parseInt(slider.dataset.minSlidesMobile) : 0;
                    const minSlidesDesktop = slider.dataset.minSlidesDesktop ? parseInt(slider.dataset.minSlidesDesktop) : 0;
                    const currentWidth = window.innerWidth;
                    const isMobile = currentWidth < 768;

                    const minRequired = isMobile ? minSlidesMobile : minSlidesDesktop;

                    if (minRequired > 0 && slideCount < minRequired) {
                        const arrows = slider.querySelector('.glide__arrows');
                        const bullets = slider.querySelector('.glide__bullets');
                        if (arrows) arrows.style.display = 'none';
                        if (bullets) bullets.style.display = 'none';
                        slider.dataset.glideInitialized = 'skipped';
                        return;
                    }

                    if (slideCount <= 1) {
                        const arrows = slider.querySelector('.glide__arrows');
                        const bullets = slider.querySelector('.glide__bullets');
                        if (arrows) arrows.style.display = 'none';
                        if (bullets) bullets.style.display = 'none';
                        slider.dataset.glideInitialized = 'skipped';
                        return;
                    }

                    const disableAbove = slider.dataset.disableAbove ? parseFloat(slider.dataset.disableAbove) : null;
                    if (disableAbove && currentWidth > disableAbove) {
                        slider.dataset.glideInitialized = 'skipped';
                        return;
                    }

                    slider.dataset.glideInitialized = 'true';

                    const perViewMobile = slider.dataset.perviewMobile ? parseFloat(slider.dataset.perviewMobile) : 1;
                    const perViewDesktop = slider.dataset.perviewDesktop ? parseFloat(slider.dataset.perviewDesktop) : 1;
                    const gap = slider.dataset.gap ? parseFloat(slider.dataset.gap) : 10;
                    const focusAt = slider.dataset.focusAt ? slider.dataset.focusAt : 0;

                    const glide = new Glide(slider, {
                        type: 'slider',
                        perView: perViewDesktop,
                        focusAt: focusAt,
                        gap: gap,
                        autoplay: false,
                        swipeThreshold: 80,
                        dragThreshold: 120,
                        keyboard: true,
                        animationDuration: 800,
                        animationTimingFunc: 'cubic-bezier(0.25, 0.8, 0.5, 1)',
                        rewind: false,
                        breakpoints: {
                            767.98: {
                                perView: perViewMobile
                            }
                        }
                    });
                    glide.mount();

                    this.setupControlsForSlider(slider, glide);
                    glideInstances.push(glide);
                }
            });

            if (glideInstances.length > 1) {
                this.synchronizeSliders(glideInstances);
            }
        }

        synchronizeSliders(glideInstances) {
            const masterSlider = glideInstances[0];
            const slaveSliders = glideInstances.slice(1);

            masterSlider.on('run', () => {
                const currentIndex = masterSlider.index;
                slaveSliders.forEach(slave => {
                    slave.go(`=${currentIndex}`);
                });
            });
        }

        setupControlsForSlider(sliderElement, glideInstance) {
            const arrows = sliderElement.querySelectorAll('.glide__arrow');

            const updateArrowsDisabled = () => {
                arrows.forEach(arrow => {
                    if (arrow.classList.contains('glide__arrow--disabled')) {
                        arrow.setAttribute('disabled', 'disabled');
                    } else {
                        arrow.removeAttribute('disabled');
                    }
                });
            };

            glideInstance.on(['mount.after', 'run'], updateArrowsDisabled);

            arrows.forEach(arrow => {
                arrow.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (arrow.hasAttribute('disabled')) return;
                    const dir = arrow.dataset.glideDir;
                    glideInstance.go(dir);
                });
            });

            const bullets = sliderElement.querySelectorAll('.glide__bullet');
            bullets.forEach(bullet => {
                bullet.addEventListener('click', (e) => {
                    e.preventDefault();
                    const dir = bullet.dataset.glideDir;
                    glideInstance.go(dir);
                });
            });
        }

        bindShopifyEvents() {
            document.addEventListener('shopify:section:load', (event) => {
                this.initSlidersInContainer(event.target);
            });
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        new GlideManager('.shopify-section');
    });
})();
